import React from "react";
import { Box, Text, HStack } from "@reverb-ui/react";
import { useTranslation } from "react-i18next";
export var CompanyCard = function (_a) {
    var name = _a.name, industry = _a.industry;
    var t = useTranslation("my-account").t;
    return (React.createElement(HStack, { width: "100%", justify: "space-around", padding: "24px" },
        React.createElement(Box, { w: "55%" },
            React.createElement(Text, { color: "gray.500" }, t("company-tab.company-name")),
            React.createElement(Text, null, name)),
        React.createElement(Box, { w: "45%" },
            React.createElement(Text, { color: "gray.500" }, t("company-tab.industry")),
            React.createElement(Text, null, industry))));
};
